/*=========================================================================================
  File Name: moduleMailServerState.js
  Description: MailServer Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
    mailServers: [],
    fullmailServers: [],
    infoDB: {},
    timeSyncMailServer:{},
  }